import { createSlice } from "@reduxjs/toolkit";
import { IWorkitem } from "@queue/types";

interface State {
  kdsInstructions: IWorkitem | null;
}

const initialState: State = {
  kdsInstructions: null,
};

export const displaySlice = createSlice({
  name: "display",
  initialState,
  reducers: {
    setKdsInstructions: (state, { payload }) => {
      state.kdsInstructions = payload;
    },
  },
});
